import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const Early = ({ color }) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="24"
    height="24"
  >
    <rect
      fill={color}
      x="75"
      y="292.63"
      width="250"
      height="25"
      rx="12.5"
      ry="12.5"
    />
    <rect
      fill={color}
      x="90"
      y="337.63"
      width="220"
      height="25"
      rx="12.5"
      ry="12.5"
    />
    <path
      fill={color}
      d="M212.63 167.09v-38.21a12.63 12.63 0 0 0-25.25 0v38.21a112.73 112.73 0 0 1 25.25 0zM288 208.76l27-27a12.63 12.63 0 0 0-17.86-17.86l-27 27A113.17 113.17 0 0 1 288 208.76zM129.88 190.9l-27-27A12.63 12.63 0 0 0 85 181.74l27 27a113.16 113.16 0 0 1 17.88-17.84zM200 216.38a62.52 62.52 0 0 1 61.22 49.87h25.37a87.51 87.51 0 0 0-173.18 0h25.37A62.52 62.52 0 0 1 200 216.38z"
    />
  </svg>
);
Early.defaultProps = {
  color: colors.blue,
};

Early.propTypes = {
  color: PropTypes.string,
};

export default Early;
